export default __webpack_public_path__ + "static/media/happy.ba453f16.png";